export const getEndpoint = (url) => `https://tamin360.ir${url}`;

export const formatNumber = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");